import React, { useState} from 'react';
import {  Grid, InputLabel, TextField, Typography } from '@material-ui/core';
import {DatePicker} from "antd";
import 'antd/dist/antd.css';
import 'moment/locale/fr';
import locale from 'antd/es/date-picker/locale/fr_FR';
import TechDetail from './TechDetail';


const List = ({ allUser, onItemClick, onSelectedDateStart, onSelectedDateEnd }) => {

    
    
    const [startDates, setStartDates] = useState(null);
    const [endDates, setEndDates] = useState(null);
    const [inputText, setInputText] = useState('');
    const [selectedId, setSelectedId] = useState(null);
   
    const results = !inputText
     ? allUser
     : allUser.filter(person =>
         person.toLowerCase().includes(inputText.toLocaleLowerCase())
       );
          
     

    const handleClick = (id) => {
      setSelectedId(id);
    };

    const inputHandler = (e) => {
      //convert input text to lower case
      const lowerCase = e.target.value;
      setInputText(lowerCase);
      
    };
 

    return (
        <div >
            <Typography variant="h4" style={{ marginLeft: "55px" }}>Chercher Votre technicien</Typography>
            <>
              <TextField
                    style={{ textAlign: 'center', marginTop: "15px", marginLeft: "50px", width: "70%" }}
                    onChange={inputHandler}
                    variant="outlined"
                    label='CHERCHER'
                    value= {inputText}
                />
                <div style={{marginLeft : '10px'}}>
                    <InputLabel className='datePickerDiv' >Date de D&eacute;but</InputLabel>
                    <DatePicker className='datePickerDiv'
                       locale={locale}
                       style={{marginLeft : '40px'}}
                        selected={startDates}
                        onChange={(date) => setStartDates(date)}
                        onSelectedDateStart={  onSelectedDateStart(startDates)}
                        showTime
                        format={date => date.format("MMM DD, YYYY HH:mm:ss")}
                        
                    />
                    <InputLabel className='datePickerDiv' >Date de Fin</InputLabel>
                    <DatePicker className='datePickerDiv' 
                       locale={locale}
                        style={{marginLeft : '40px'}}
                        selected={endDates}
                        onChange={(date) => setEndDates(date)}
                        onSelectedDateEnd={  onSelectedDateEnd(endDates)}
                        showTime
                        format={date => date.format("MMM DD, YYYY HH:mm:ss")}
                    />
                </div>
                <Grid container  className="list" >  
                    <Grid item xs={12} >
                    
                        <Typography gutterBottom style={{ fontWeight: 'bold' }}>TECHNICIENS</Typography>
                   
                        {
                           (startDates !== null && endDates !== null ) ?
                            results?.map((user, ind) => <TechDetail key={ind} user={user} onClick={() => { handleClick(user); onItemClick(user) }}
                                selected={user === selectedId} />) :  null
                        }
                      
                         
                    </Grid>
                </Grid>
            </>
        </div>

    );
};

export default List;
